const roles = {
    admin: 'ADMIN',
    astrauser: 'ASTRAUSER',
    doctor: 'DR'
}

export default roles;